<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Cek IMEI</h5>
            </template>

            <div class="d-flex search-input-wrapper my-2">
                <b-form-input class="ml-2 mr-2" v-model="filter.filterImei" name="filterImei" id="filterInput" type="search"
                    placeholder="Masukkan IMEI">
                </b-form-input>
                <b-form-input class="mr-2" v-model="filter.filterTipe" name="filterTipe" type="search"
                    placeholder="Masukan Tipe Barang ">
                </b-form-input>
                <b-form-select class="mr-2" v-model="filter.filterStatus" name="statusKeringanan"
                    :options="statusKeringanan" value-field="id" text-field="name">
                    <template v-slot:first>
                        <b-form-select-option :value="null" disabled>-- Pilih Status --</b-form-select-option>
                    </template>
                </b-form-select>
                <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="onFilter">
                    <i class="fa fa-search"></i>
                </b-button>
                <b-button variant="pgiBtn" class="mx-2" name="resetTableBtn" :disabled="isBusy" @click="onReset">Reset</b-button>
                <b-button variant="success" name="resetTableBtn" :disabled="isBusy" @click="$bvModal.show('modal-export')">Export</b-button>
            </div>

            <b-table bordered hover show-empty :busy="isBusy" :items="data" :fields="fields" :no-local-sorting="false"
                @sort-changed="sortingChanged" responsive class="mb-3">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong> Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data IMEI.
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge v-if="row.item.status == 2" variant="success">Processesed</b-badge>
                    <b-badge v-if="row.item.status == 1" variant="info">On Check</b-badge>
                    <b-badge v-if="row.item.status == 0" variant="warning">Pending</b-badge>
                    <b-badge v-if="row.item.status == 3" variant="danger">Tolak</b-badge>
                </template>
                <template v-slot:cell(createdAt)="row">
                    {{ $helper.changeDateFormat(row.item.createdAt) }}
                    {{ $helper.changeDateFormatGetHour(row.item.createdAt) }}
                </template>
                <template v-slot:cell(action)="row">
                    <b-button class="btn btn-sm" variant="primary" @click="detail(row.item.id)">
                        <i class="fa fa-info"></i>
                    </b-button>
                </template>
            </b-table>

            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                    <b-form-select v-model="filter.show" id="showItems" :options="PageOptions" @change="onLimitChange">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled />
                        </template>
                    </b-form-select>
                    <span class="ml-2">{{ totalViewText }}</span>
                </b-input-group>
                <b-pagination class="mb-0" v-model="currentPage" :total-rows="rows" :per-page="perPage"
                    aria-controls="my-table" @input="onPageChange"></b-pagination>
            </div>
        </b-card>
        <b-modal id="modal-detail" title="Detail IMEI" no-close-on-backdrop>
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title mb-2">Data Umum</h6>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Tipe Barang</b-col>
                    <b-col>
                        {{ dataDetail && dataDetail.tipeBarang.name }}
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">IMEI</b-col>
                    <b-col>
                        {{ dataDetail && dataDetail.imei }}
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Status</b-col>
                    <b-col>
                        <b-badge v-if="dataDetail && dataDetail.status == 2" variant="success">Processesed</b-badge>
                        <b-badge v-if="dataDetail && dataDetail.status == 1" variant="info">On Check</b-badge>
                        <b-badge v-if="dataDetail && dataDetail.status == 0" variant="warning">Pending</b-badge>
                        <b-badge v-if="dataDetail && dataDetail.status == 3" variant="danger">Tolak</b-badge>
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Spek</b-col>
                    <b-col>
                        <div v-if="dataDetail && dataDetail.spek == 2">RESMI</div>
                        <div v-else-if="dataDetail && dataDetail.spek == 5">LN</div>
                        <div v-else>-</div>
                    </b-col>
                </b-row>
                <b-row class="mb-2" v-if="dataDetail && dataDetail.invoices.length != 0">
                    <b-col cols="5" class="detail-data-label">No. Faktur</b-col>
                    <b-col>
                        <div v-for="item of dataDetail.invoices" :key="item">
                            - <a href="javascript:void(0)" @click="navigateToGadaiInquiryFaktur(item, $event)">{{ item
                            }}</a>
                        </div>
                    </b-col>
                </b-row>

                <MFotoPendukung :data="dataDetail" @fetchData="detail"
                    :hasAccess="hasAccess && dataDetail && dataDetail.status != 2" />
          
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button v-if="hasAccess && dataDetail.status != 1 && dataDetail.status == 0" variant="pgiBtn"
                    :disabled="loading" name="closeDetailBtn" @click="$bvModal.show('confirm-set-check')">
                    {{ loading ? 'Loading...' : 'Update On Check' }}
                </b-button>
                <b-button v-if="hasAccess && dataDetail.status == 0 || dataDetail.status == 1" variant="success"
                    :disabled="loading" name="closeDetailBtn" @click="$bvModal.show('confirm-set-resmi')">
                    {{ loading ? 'Loading...' : 'Set RESMI' }}
                </b-button>
                <b-button v-if="hasAccess && dataDetail.status == 0 || dataDetail.status == 1" variant="dark"
                    :disabled="loading" name="closeDetailBtn" @click="$bvModal.show('confirm-set-ln')">
                    {{ loading ? 'Loading...' : 'Set LN' }}
                </b-button>
                <b-button v-if="hasAccess && dataDetail.status == 0 || dataDetail.status == 1" variant="danger"
                    :disabled="loading" name="closeDetailBtn" @click="$bvModal.show('confirm-set-tolak')">
                    {{ loading ? 'Loading...' : 'Set Tolak' }}
                </b-button>
            </template>
        </b-modal>

        <b-modal id="modal-export" title="Export" no-close-on-backdrop>
            <div>
                Ambil IMEI dari tanggal     
                <b-form-input
                class="my-2"
                    v-model="exportStartDate" name="filterFromDate"
                    id="filterInput"
                    type="date"
                ></b-form-input> 
                sampai hari ini
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" :disabled="loading" name="closeDetailBtn" @click="cancel()">
                    {{ loading ? 'Loading...' : 'Tutup' }}
                </b-button>
                <b-button variant="pgiBtn" :disabled="loading" name="closeDetailBtn" @click="modalDownload">
                    {{ loading ? 'Loading...' : 'Export' }}
                </b-button>
            </template>
        </b-modal>

        <ModalConfirm id="confirm-set-check" title="Konfirmasi set status on check" :isSubmitting="loading"
            desc="Apakah anda yakin untuk mengubah status ini menjadi On Check?" @submit="setStatusOnCheck()" />
        <ModalConfirm id="confirm-set-resmi" title="Konfirmasi set status RESMI" :isSubmitting="loading"
            desc="Apakah anda yakin untuk mengubah status ini menjadi RESMI?" @submit="setStatus(2)" />
        <ModalConfirm id="confirm-set-ln" title="Konfirmasi set status LN" :isSubmitting="loading"
            desc="Apakah anda yakin untuk mengubah status ini menjadi LN?" @submit="setStatus(5)" />
        <ModalConfirm id="confirm-set-tolak" title="Konfirmasi set status Tolak" :isSubmitting="loading"
            desc="Apakah anda yakin untuk mengubah status ini menjadi Tolak?" @submit="setStatus(3)" />
        <ModalConfirm id="modal-confirm-download" title="Confirm Export" desc="Apakah anda yakin untuk Export ini?" @submit="onDownloadOrder()" />
        
        <b-modal id="modal-download-export" centered title="Download Export" hide-footer no-close-on-backdrop>
            <div class="text-center" v-if="isLoadLink == true">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div class="show-btn-download" v-else>
                <p class="">
                    Silakan download dengan klik tombol dibawah ini :
                </p>
                <b-button variant="pgiBtn" class="mb-0 download-btn">
                    <a v-bind:href="$baseFilePath + filePathDownload" download>
                        <i class="fa fa-download mr-2"></i>
                        Download Export
                    </a>
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import MFotoPendukung from './MFotoPendukung.vue'

export default {
    name: 'cek-gadai',
    components: {
        MFotoPendukung
    },
    data() {
        return {
            initStatus: 0,
            isBusy: true,

            hasAccess: (localStorage.getItem('menuChildren').includes("PCI")) ? true : false,
            statusKeringanan: [
                { id: 0, name: 'Pending' },
                { id: 1, name: 'On Check' },
                { id: 2, name: 'Processed' },
                { id: 3, name: 'Tolak' },
            ],
            filter: {
                show: 10,
                filterImei: null,
                filterTipe: null,
                filterStatus: null,
                sortBy: null,
                sortDesc: null
            },
            fields: [
                { key: "tipeBarang.name", label: "Tipe Barang" },
                { key: "imei", label: "IMEI" },

                { key: "status", label: "Status" },
                { key: "action", label: "Aksi" }
            ],
            PageOptions: [
                { value: 10, text: '10' },
                { value: 20, text: '20' },
                { value: 30, text: '30' },
                { value: 40, text: '40' },
                { value: 50, text: '50' },
            ],
            data: [],
            dataDetail: null,

            exportStartDate:null,

            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            loading: false,
            query: "",

            isLoadLink: false,
            filePathDownload:"",
        }
    },

    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init() {
            this.initStatus = 0
            this.page = 0
            this.size = this.filter.show
            this.query = this.$helper.makeQuery(this.page, this.size)

            let getImei = this.$axios.get("imei-check/" + this.query).then(response => {
                this.data = response.data.data
                this.updateTotalItem(response.data.total)
            })

            Promise.all([getImei]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
                .catch(error => {
                    console.log(error)
                    this.initStatus = -1
                })
        },

        getImei() {
            this.toggleBusy()
            this.data = []

            if (this.filter.filterTipe != null) this.query = this.query + "&filterTipe=" + this.filter.filterTipe
            if (this.filter.filterImei != null) this.query = this.query + "&filterImei=" + this.filter.filterImei
            if (this.filter.filterStatus != null) this.query = this.query + "&filterStatus=" + this.filter.filterStatus

            this.$axios.get("imei-check/" + this.query).then(response => {
                this.data = response.data.data
                this.toggleBusy()
                this.updateTotalItem(response.data.total)
                this.loading = false
            })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                    this.toggleBusy()
                    this.loading = false
                })
        },

        detail(id) {
            try {
                this.loading = true
                this.$axios.get("imei-check/" + id).then(async response => {
                    this.dataDetail = await response.data
                    this.loading = false
                    this.$bvModal.show('modal-detail')
                })
            } catch (error) {
                console.error
                this.loading = false
            }
        },

        setStatusOnCheck() {
            this.loading = true

            this.$axios.post("imei-check/update-on-check?id=" + this.dataDetail.id).then(response => {
                this.detail(this.dataDetail.id)
                this.getImei()
                this.$bvModal.hide('confirm-set-check')
                this.$helper.toastSucc(this, "Status berhasil diubah!")
                this.loading = false
            })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                    this.loading = false
                })
        },

        setStatus(status) {
            this.loading = true

            if (status != 3) {
                this.$axios.post(`imei-check/process?id=${this.dataDetail.id}&spekId=${status}`).then(response => {
                    this.detail(this.dataDetail.id)
                    this.getImei()
                    this.$bvModal.hide('confirm-set-resmi')
                    this.$bvModal.hide('confirm-set-ln')
                    this.$helper.toastSucc(this, "Status berhasil diubah!")
                    this.loading = false
                })
                    .catch(error => {
                        console.log(error)
                        console.log(error.response.data.reason)
                        this.$helper.parseError(this, error)
                        this.loading = false
                    })

            } else {
                this.$axios.post(`/imei-check/reject?id=${this.dataDetail.id}`).then(response => {
                    this.detail(this.dataDetail.id)
                    this.getImei()
                    this.$bvModal.hide('confirm-set-tolak')
                    this.$helper.toastSucc(this, "Status berhasil diubah!")
                    this.loading = false
                })
                    .catch(error => {
                        console.log(error)
                        console.log(error.response.data.reason)
                        this.$helper.parseError(this, error)
                        this.loading = false
                    })
            }
        },

        navigateToGadaiInquiryFaktur(item) {
            this.$router.push(`/gadai/inquiry-faktur/${item}`);
        },

        navigateToGadaiInquiryFaktur(item, event) {
            // Construct the URL based on item
            const url = this.generateUrlForFaktur(item);

            // Open the URL in a new tab
            const newTab = window.open(url, '_blank');

            // If new tab couldn't be opened, fallback to same tab
            if (!newTab || newTab.closed || typeof newTab.closed == 'undefined') {
                window.location.href = url;
            }
        },
        generateUrlForFaktur(item) {
            // Replace with your actual URL generation logic
            return `/gadai/inquiry-faktur/${item}`;
        },

        modalDownload(){
            if (this.exportStartDate == null) {
               return this.$helper.toastErr(this, "Mohon isi tanggal mulai!")
            }
           this.$bvModal.show('modal-confirm-download')
        },

        onDownloadOrder(){
            this.isLoadLink = true
            this.$bvModal.show('modal-download-export')
            this.$bvModal.hide('modal-confirm-download')
            setTimeout(() => { this.axiosDownloadExcel() }, 500)
        },

        axiosDownloadExcel(){
            this.$axios.get("imei-check/export?startDate="+this.exportStartDate).then(response => {
                this.filePathDownload = response.data.name
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isLoadLink = false
            })
        },

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        onLimitChange() {
            this.size = this.filter.show
            this.perPage = this.filter.show
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.getImei()
        },

        onPageChange() {
            if (this.loading == false) {
                this.page = this.currentPage - 1
                this.query = this.$helper.makeQuery(this.page, this.size)
                this.getImei()
            }
        },

        sortingChanged(ctx) {
            if (ctx.sortBy == "persen") {
                this.filter.sortBy = "nominalPersen"
                this.filter.sortDesc = ctx.sortDesc
                this.onFilter()
            } else if (ctx.sortBy != "") {
                this.filter.sortBy = ctx.sortBy
                this.filter.sortDesc = ctx.sortDesc
                this.onFilter()
            }
        },

        onReset() {
            this.filter.filterTipe = null
            this.filter.filterImei = null
            this.filter.filterStatus = null
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getImei()
        },

        onFilter() {
            this.page = 0
            this.currentPage = 1
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getImei()
        },

        updateTotalItem(total) {
            let limit = null
            let prevLimit = null
            this.perPage = this.size
            this.rows = total
            prevLimit = this.page * this.size + 1
            limit = this.page * this.size + this.size
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan " + prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        toggleBusy() {
            if (this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

    },

    created() {
        this.init()
    }
}
</script>
